import React from 'react'
import css from './index.module.scss'
import { IconWinner,IconStruggle,IconTopper } from 're_redesigned_componnents/icon'
function StudentStatusCard({total=100,struggling=30,excelling=70}) {
  return (
    <div className={css.studentStat}>
    <div className={css.statTitle}>
      <h4>Class Stastistics</h4>
      <h4>Class List</h4>
    </div>
    <div className={css.statcontent}>
    <div className={css.statItem}>
    <IconTopper/>
    <h4>{total}</h4>
    <p>Total Students</p>
        </div> 
        <div className={css.statItem}>
        <IconStruggle/>
        <h4>{struggling}</h4>
        <p>Struggling</p>
        </div> 
        <div className={css.statItem}>
        <IconWinner/>
        <h4>{excelling}</h4>
        <p>Exceling</p>
        </div> 
    </div>
   </div>
  )
}

export default StudentStatusCard